// src/pages/SsoCallback.jsx
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { clearSession, setLoginError } from "../utils/session";

function errorMessage(code) {
  const messages = {
    access_denied: "Google sign-in was cancelled.",
    oauth_session_expired: "Your sign-in session expired. Please try again.",
    oauth_state_mismatch: "Sign-in validation failed. Please try again.",
    account_deactivated:
      "Your account has been deactivated. Contact admin to reactivate.",
  };
  return messages[code] || "Google sign-in failed. Please try again.";
}

export default function SsoCallback() {
  const navigate = useNavigate();
  const { login } = useAuth();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    const error = params.get("error");

    if (error) {
      clearSession();
      setLoginError(errorMessage(error));
      navigate("/login", { replace: true });
      return;
    }

    if (!token) {
      setLoginError("No sign-in token was returned. Please try again.");
      navigate("/login", { replace: true });
      return;
    }

    try {
      // login() decodes the token and stores {id, email, roles, orgId} in
      // localStorage (same access_token/user keys utils/session.js uses),
      // and kicks off the effective-permissions map fetch.
      login(token);
    } catch (err) {
      console.error("[SSO] error parsing token:", err);
      clearSession();
      setLoginError("Could not complete sign-in. Please try again.");
      navigate("/login", { replace: true });
      return;
    }

    // After storing token, let ProtectedOutlet render the app; WorkspaceProvider
    // fetches accounts/engagements once isAuthenticated flips.
    navigate("/", { replace: true });
  }, [navigate, login]);

  return null;
}
